var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdtColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09604 23.6434C15.5262 25.2467 22.0381 21.3339 23.6409 14.9045H23.6409L23.6408 14.9047C25.2438 8.475 21.3312 1.96199 14.9016 0.359126C8.47347 -1.24374 1.96157 2.66933 0.359412 9.0994C-1.24416 15.5282 2.66862 22.0405 9.09604 23.6434ZM12.0193 12.9572C13.0671 12.9572 13.5368 12.9292 13.6277 12.9224L13.6247 12.9216C16.8392 12.7792 19.2371 12.2185 19.2371 11.5488C19.2371 10.8791 16.8385 10.3184 13.6247 10.1753V12.3647C13.5345 12.3731 13.0338 12.4148 12.0337 12.4148C11.2003 12.4148 10.5973 12.3791 10.3867 12.364V10.1737C7.16605 10.3177 4.76215 10.8776 4.76215 11.5488C4.76215 12.22 7.16605 12.7807 10.3867 12.9224C10.5942 12.9322 11.1859 12.9572 12.0193 12.9572ZM13.6277 9.948V9.94872L13.627 9.94797C13.6272 9.94798 13.6275 9.94799 13.6277 9.948ZM13.6277 7.98878V9.948C17.2661 10.1163 20 10.8375 20 11.7018C20 12.5663 17.2635 13.2875 13.627 13.455V19.7378H10.3859V13.4572C6.74103 13.289 3.99999 12.5678 3.99999 11.7026C3.99999 10.8374 6.74103 10.1154 10.3859 9.94797V7.98878H5.90159V5H18.1128V7.98878H13.6277Z",
    fill: "#DAA636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtColor);
export default __webpack_public_path__ + "static/media/USDTColor.d0a0b71f1937db6577d1d155fd500e57.svg";
export { ForwardRef as ReactComponent };